import React from 'react';
import { connect } from 'react-redux';
import { Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import ShopForm from '../Form';
import { createShop } from '@resources/Shop/actions';
import { useIntl } from 'react-intl';

const Create = (props) => {
	const { createShop, visible, onCancel } = props;
	const intl = useIntl();
	const handleSubmit = (data) => {
		return createShop(data)
			.then((response) => {
				popIn(
					'success',
					intl.formatMessage({
						id: 'message.success.shop.create',
						defaultMessage:
							'A new Shop has been successfully created',
					})
				);

				onCancel && onCancel();
			})
			.catch((err) => Promise.reject(err));
	};

	return (
		<Modal visible={visible} onCancel={() => onCancel && onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.new.shop',
					defaultMessage: 'Create Shop',
				})}
			</Title>
			<ShopForm onSubmit={handleSubmit} {...props} />
		</Modal>
	);
};

const mapStateToProps = ({ organization }) => {
	return {
		organization,
	};
};

export default connect(mapStateToProps, { createShop })(Create);
